<template>
  <div>
    <van-popup
      v-model="show"
      position="bottom"
      round
      class="my-popup"
      @close="bindClose"
    >
      <div class="toast-container">
        <div class="toast-top">
          <div class="t-title">拉票明细</div>
          <div class="t-info">累计{{ inviteList.length }}次拉票</div>
        </div>
        <div class="t-scorll">
          <van-loading class="loading" v-if="loading" />
          <div class="t-list">
            <div
              class="t-item"
              v-for="(item, index) in inviteList"
              :key="index"
            >
              <div class="item-name">{{ item.nickname || '匿名' }}</div>
              <div class="item-time">{{ item.created_at }}</div>
            </div>
            <div class="not-data" v-if="!loading && !inviteList.length"
              >暂无拉票</div
            >
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: []
    },
    activityId: {
      type: Number,
      default: 1
    }
  },
  watch: {
    value() {
      this.show = this.value
      if (this.value) {
        this.getInviteList()
      }
    }
  },
  data() {
    return {
      loading: false,
      show: false,
      inviteList: []
    }
  },
  created() {
    this.show = this.value
  },
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    async getInviteList() {
      this.loading = true
      let res = await this.$http
        .getApp('api/v1/Vote/voteInviteRecord', {
          activity_id: this.activityId
        })
        .catch(() => {
          this.loading = false
        })
      if (res) {
        this.loading = false
        res = res.data
        if (res.code == 200) {
          this.inviteList = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.toast-container {
  padding: 20px;

  .toast-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .t-title {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
    }

    .t-info {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }
  }

  .t-scorll {
    position: relative;
    height: 200px;
    overflow-y: scroll;
  }

  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .t-list {
    .t-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;

      .item-name {
        width: 170px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .item-time {
        width: 130px;
        text-align: left;
        font-size: 12px;
      }
    }

    .not-data {
      text-align: center;
      margin-top: 50px;
      color: rgba(0, 0, 0, 0.6);
    }
  }
}
</style>
